export default __webpack_public_path__ + "static/icon-5-1-8152c95509587eeafaa5e74e15df7a19.png";